"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAGE_DOT = exports.TIMESTAMP = exports.SNL_SLENE_NAME_BY_NUMBER = exports.EMPTY_CONFIG = exports.PSEUDO_STYLES = exports.PSEUDO_CONTENT = exports.PADDED_EM_DASH = exports.EM_DASH = void 0;
const types_1 = require("../types");
exports.EM_DASH = '\\2014';
exports.PADDED_EM_DASH = [' ', exports.EM_DASH, ' '];
exports.PSEUDO_CONTENT = {
    // 2.
    PAGE_DOT: [[types_1.ZMarginVariablesEnum.enum.docPage], '.'],
    // Page 3 of 17
    PAGE_OF_TOTAL: [
        'Page ',
        [types_1.ZMarginVariablesEnum.enum.docPage],
        ' of ',
        [types_1.ZMarginVariablesEnum.enum.docPageCount],
    ],
    // Sample Studio Script
    DOCUMENT_TITLE: [[types_1.ZMarginVariablesEnum.enum.docTitle]],
    // 4/6/2022 at 7:02am
    TIMESTAMP: [[types_1.ZMarginVariablesEnum.enum.timestamp]],
    // Act One: The Beginning
    ACT_NAME: [[types_1.ZMarginVariablesEnum.enum.actName]],
    // Missing Fence
    SLENE_NAME: [[types_1.ZMarginVariablesEnum.enum.sleneName]],
    // 2 Missing Fence
    PRE_NUMBERED_SLENE: [
        [types_1.ZMarginVariablesEnum.enum.sleneNumber],
        ' ',
        [types_1.ZMarginVariablesEnum.enum.sleneName],
    ],
    // ACT ONE - MISSING FENCE
    ACT_DASH_SLENE: [
        [types_1.ZMarginVariablesEnum.enum.actName],
        ...exports.PADDED_EM_DASH,
        [types_1.ZMarginVariablesEnum.enum.sleneName],
    ],
    // 1a or 4 (the number assigned to the number manually or automatically)
    SLENE_NUMBER: [[types_1.ZMarginVariablesEnum.enum.sleneNumber]],
};
exports.PSEUDO_STYLES = {
    CAPS: { textTransform: 'uppercase' },
    UNDERLINE: { textDecoration: 'underline' },
    RIGHT_ALIGN: { textAlign: 'right' },
};
exports.EMPTY_CONFIG = [
    [null, null],
    [null, null],
];
const flattenStyles = (styles) => {
    if (Array.isArray(styles)) {
        let result = {};
        styles.forEach((s) => {
            result = { ...result, ...s };
        });
        return result;
    }
    return styles;
};
const mergeQOpts = ({ content, styles, exclusions, }) => ({
    content,
    exclusions,
    styles: styles ? flattenStyles(styles) : styles,
});
const assembleSlotConfig = ({ topRowBefore, topRowAfter, bottomRowBefore, bottomRowAfter, }) => [
    [
        topRowBefore ? mergeQOpts(topRowBefore) : null,
        topRowAfter ? mergeQOpts(topRowAfter) : null,
    ],
    [
        bottomRowBefore ? mergeQOpts(bottomRowBefore) : null,
        bottomRowAfter ? mergeQOpts(bottomRowAfter) : null,
    ],
];
exports.SNL_SLENE_NAME_BY_NUMBER = assembleSlotConfig({
    topRowBefore: {
        content: exports.PSEUDO_CONTENT.SLENE_NAME,
        styles: [
            exports.PSEUDO_STYLES.UNDERLINE,
            exports.PSEUDO_STYLES.CAPS,
            exports.PSEUDO_STYLES.RIGHT_ALIGN,
        ],
        exclusions: {
            slene: [0],
        },
    },
    // the big slene number thing that snl likes
    topRowAfter: {
        content: exports.PSEUDO_CONTENT.SLENE_NUMBER,
        styles: {
            fontSize: '1.5em',
            fontWeight: 'bold',
            position: 'absolute',
            left: 'calc(100% + 20px)',
            top: '-20px',
            width: 'unset',
        },
        exclusions: {
            slene: [0],
        },
    },
    bottomRowBefore: {
        content: ['Page ', [types_1.ZMarginVariablesEnum.enum.slenePage]],
        styles: [exports.PSEUDO_STYLES.RIGHT_ALIGN],
        exclusions: {
            slene: [0],
        },
    },
});
exports.TIMESTAMP = assembleSlotConfig({
    topRowBefore: {
        content: exports.PSEUDO_CONTENT.TIMESTAMP,
        styles: null,
        exclusions: null,
    },
});
exports.PAGE_DOT = assembleSlotConfig({
    topRowBefore: {
        content: exports.PSEUDO_CONTENT.PAGE_DOT,
        exclusions: { doc: [1] },
        styles: null,
    },
});
